// qlf-omega3-calculator.js
// Omega-3 Calculator
(function () {
  'use strict';

  function initOmega3Calculator() {
    // Check if calculator exists on page
    const calculatorForm = document.getElementById('o3Form');
    if (!calculatorForm) return;

    // Get DOM elements
    const weightInput = document.getElementById('weight');
    const fishSelect = document.getElementById('fish');
    const calcButton = document.getElementById('calcBtn');
    const resultContainer = document.getElementById('result');
    const capsulesElement = document.getElementById('capsules');

    // Guard: if any element missing, do nothing
    if (!weightInput || !fishSelect || !calcButton || !resultContainer || !capsulesElement) return;

    // Mapping von Select-Werten zu Omega-3-Index Werten
    const omega3IndexMap = {
      never: 4.48, // Nie
      '0.5x': 4.78, // 1 mal in 2 Wochen
      '1x': 5.14, // 1 mal pro Woche
      '2x': 5.71, // 2 mal pro Woche
      '3x': 6.46 // 3 mal pro Woche +
    };

    // Validation function
    function isFormValid() {
      const weight = Number(weightInput.value);
      const fishValue = fishSelect.value;
      return weight > 0 && fishValue !== '';
    }

    // Update button state
    function updateButtonState() {
      calcButton.disabled = !isFormValid();
    }

    // Calculate recommended capsules
    function calculateCapsules(weight, fishFrequency) {
      const activity = omega3IndexMap[fishFrequency];

      // Falls ein unbekannter Wert im Select landet
      if (typeof activity !== 'number' || Number.isNaN(activity)) return 0;

      // Formula from original code:
      // result = 1000 * (weight * ((9.5 - activity - 0.56) / 200))
      // capsules = Math.ceil(result / 350)
      const result = 1000 * (weight * ((9.5 - activity - 0.56) / 200));
      const capsules = Math.ceil(result / 350);

      return capsules;
    }

    // Show result and scroll to it
    function showResult(capsuleCount) {
      capsulesElement.textContent = String(capsuleCount);
      resultContainer.hidden = false;

      resultContainer.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    // Handle calculation
    function handleCalculation(event) {
      if (event) event.preventDefault();
      if (!isFormValid()) return;

      const weight = Number(weightInput.value);
      const fishFrequency = fishSelect.value;

      const capsules = calculateCapsules(weight, fishFrequency);
      showResult(capsules);
    }

    // Event listeners
    weightInput.addEventListener('input', updateButtonState);
    fishSelect.addEventListener('change', updateButtonState);
    calcButton.addEventListener('click', handleCalculation);

    // Handle Enter key in weight input
    weightInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        if (!calcButton.disabled) handleCalculation(event);
      }
    });

    // Initialize button state
    updateButtonState();
  }

  // Ensure DOM is ready even if the script loads in <head> or before the markup
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOmega3Calculator);
  } else {
    initOmega3Calculator();
  }
})();
